import { getActivityBasedFormFlowFactory } from "../form-flow-engine-initializer.js";
export async function invokeActivityBasedFormFlowAsync(formFlowDefinition, input, options) {
    const factory = getActivityBasedFormFlowFactory();
    const formFlow = await factory.build(formFlowDefinition, input, options);
    try {
        const startActivityId = formFlow.findStartActivityId();
        await formFlow.invokeActivity(startActivityId);
        const output = extractOutputResult(formFlowDefinition, formFlow);
        await formFlow.onComplete();
        return output;
    }
    finally {
        await factory.dispose(formFlow);
    }
}
function extractOutputResult(formFlowDefinition, formFlow) {
    return formFlowDefinition.OutParameters?.reduce((result, outParam) => {
        const value = formFlow.getVariableValue(outParam.Name);
        result[outParam.Name] = value;
        return result;
    }, {});
}
